import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["id", "checked"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 1,
  class: "field"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "JSON payload", -1)
const _hoisted_9 = { class: "control" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "help"
}
const _hoisted_13 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Configuration", -1)
const _hoisted_15 = ["field"]
const _hoisted_16 = { class: "field-label is-normal" }
const _hoisted_17 = { class: "field-body" }
const _hoisted_18 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_19 = ["field"]
const _hoisted_20 = { class: "field-label is-normal" }
const _hoisted_21 = { class: "field-body" }
const _hoisted_22 = {
  key: 0,
  class: "help is-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownContent = _resolveComponent("DropdownContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newConfiguration.name) = $event)),
        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.newConfiguration))),
        disabled: _ctx.loading || undefined
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.newConfiguration.name]
      ])
    ]),
    (_ctx.schema)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createElementVNode("input", {
            id: `JSONStringSwitch${_ctx.uid}`,
            type: "checkbox",
            class: "switch is-rtl is-rounded is-info",
            checked: _ctx.JSONStringToggled,
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleJSONStringMode && _ctx.toggleJSONStringMode(...args)))
          }, null, 40, _hoisted_5),
          _createElementVNode("label", {
            class: "is-pulled-right",
            for: `JSONStringSwitch${_ctx.uid}`
          }, "JSON", 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    (_ctx.JSONStringMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["textarea is-family-monospace", { 'is-danger': Boolean(_ctx.JSONConfigError) }]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stringConfiguration) = $event)),
              disabled: _ctx.loading || undefined,
              placeholder: "{}"
            }, null, 10, _hoisted_10), [
              [_vModelText, _ctx.stringConfiguration]
            ]),
            (_ctx.JSONConfigError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.JSONConfigError), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, "You can define here any JSON object that will be made available to the worker when it runs."))
          ])
        ]))
      : (Object.keys(_ctx.newConfiguration.configuration).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            (_ctx.schemaRequired)
              ? (_openBlock(), _createBlock(_component_DropdownContent, {
                  key: 0,
                  id: "configurationRequired",
                  title: `Required fields (${Object.values(_ctx.schemaRequired).length})`
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemaRequired, (field, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "field",
                        key: key,
                        field: field
                      }, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(field.title), 1),
                        _createElementVNode("div", _hoisted_17, [
                          (_ctx.FIELDS[field.type])
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.FIELDS[field.type].component), {
                                key: 0,
                                field: field,
                                "field-id": `config-field-id-${_ctx.uid}-${key}`,
                                class: _normalizeClass({ 'is-danger': Boolean(_ctx.configurationErrors[key]) }),
                                modelValue: _ctx.newConfiguration.configuration[key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.newConfiguration.configuration[key]) = $event),
                                "worker-id": _ctx.workerId
                              }, null, 8, ["field", "field-id", "class", "modelValue", "onUpdate:modelValue", "worker-id"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.configurationErrors[key] && field.type !== 'list')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.configurationErrors[key]), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_15))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.schemaOptional)
              ? (_openBlock(), _createBlock(_component_DropdownContent, {
                  key: 1,
                  id: "configurationOptional",
                  title: `Optional fields (${Object.values(_ctx.schemaOptional).length})`,
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemaOptional, (field, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "field",
                        key: key,
                        field: field
                      }, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(field.title), 1),
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.FIELDS[field.type])
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.FIELDS[field.type].component), {
                                key: 0,
                                field: field,
                                "field-id": `config-field-id-${_ctx.uid}-${key}`,
                                class: _normalizeClass({ 'is-danger': Boolean(_ctx.configurationErrors[key]) }),
                                modelValue: _ctx.newConfiguration.configuration[key],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.newConfiguration.configuration[key]) = $event),
                                "worker-id": _ctx.workerId
                              }, null, 8, ["field", "field-id", "class", "modelValue", "onUpdate:modelValue", "worker-id"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.configurationErrors[key] && field.type !== 'list')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.configurationErrors[key]), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ], 64))
}